import scrollLock from 'scroll-lock';

export default class Menu {
	static init(){
		const headerWrapper = document.querySelector('.m-header');
		new Menu(headerWrapper);
	}

	constructor(headerWrapper){

		this.headerWrapper = headerWrapper;
		this.hamburger = this.headerWrapper.querySelector('.c-hamburger');
		this.menu = document.querySelector('.c-menu');


		if (!this.hamburger) {
			return;
		}

		this.menuOpen = false;

		this.hamburger.addEventListener('click', e => {
			this.toggleMenu();
		});

		let FocusableElements = this.menu.querySelectorAll('li');

		const firstTarget = FocusableElements[0];
		const lastTarget = FocusableElements[FocusableElements.length - 1];

		const firstFocusableEl = firstTarget.firstElementChild;
		const lastFocusableEl = lastTarget.firstElementChild;

		if (window.innerWidth < 992) {
			window.addEventListener('keydown', e => {

				if (e.key === 'Escape') {
					this.closeMenu();
				}

				if (e.key === 'Tab' || e.key === 9) {
					if ( e.shiftKey ) /* shift + tab */ {
						if (document.activeElement === firstFocusableEl) {
							lastFocusableEl.focus();
							e.preventDefault();
						}
					} else /* tab */ {
						if (document.activeElement === lastFocusableEl) {
							firstFocusableEl.focus();
							e.preventDefault();
						}
					}
				}
			});
		}

		//Show and hide header bar based on scroll direction
		let lastScroll = 0;

		const throttle = (func, time = 100) => {
		let lastTime = 0;
			return () => {
				const now = new Date();
				if (now - lastTime >= time) {
				func();
				time = now;
				}
			};
		};

		const validateHeader = () => {
			const windowY = window.scrollY;
			const windowH = window.innerHeight;
			if (windowY > windowH) {
				this.headerWrapper.classList.add('is-fixed');
				if (windowY > windowH + 40) {
					this.headerWrapper.classList.add('can-animate');
				if (windowY < lastScroll) {
					this.headerWrapper.classList.add('scroll-up');
				} else {
					this.headerWrapper.classList.remove('scroll-up');
				}
				} else {
					this.headerWrapper.classList.remove('scroll-up');
				}
			} else {
				this.headerWrapper.classList.remove('is-fixed', 'can-animate');
			}
			lastScroll = windowY;
		};

		window.addEventListener('scroll', throttle(validateHeader, 100));

	}

	toggleMenu() {
		this.menuOpen ? this.closeMenu() : this.openMenu();
	}

	openMenu() {
		this.menuOpen = true;

		scrollLock.disablePageScroll();

		document.body.classList.add('has-menu-open');

		this.menu.classList.add('is-active');

		this.hamburger.classList.add('is-active');
		this.hamburger.setAttribute('aria-expanded', true);
		this.hamburger.setAttribute('aria-label', 'button - close navigation menu');
	}

	closeMenu() {
		if (!this.menuOpen) {
			return new Promise(resolve => {
				resolve();
			});
		}

		this.menuOpen = false;

		scrollLock.enablePageScroll();

		document.body.classList.remove('has-menu-open');

		this.menu.classList.remove('is-active');
		// this.subMenu.classList.remove('is-active');

		this.hamburger.classList.remove('is-active');
		this.hamburger.setAttribute('aria-expanded', false);
		this.hamburger.setAttribute('aria-label', 'button - open navigation menu');
	}
}
